import { Component, Output, EventEmitter, Input, ViewChild } from '@angular/core';

import { ModalComponent, TrapFocusComponent } from 'remarketing-ui-components-lib';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-remove-mobile-phone-modal',
    templateUrl: './remove-mobile-phone-modal.component.html',
    styleUrls: ['./remove-mobile-phone-modal.component.scss'],
    imports: [TranslocoDirective, TrapFocusComponent, ModalComponent]
})
export class RemoveMobilePhoneModalComponent {
  @ViewChild(ModalComponent) modal: ModalComponent;

  @Output() removed = new EventEmitter();
  @Output() canceled = new EventEmitter();

  @Input() modalId = 'remove-mobile-phone-modal';

  show() {
    this.modal.show();
  }

  cancel() {
    this.canceled.emit();
    this.close();
  }

  remove() {
    this.removed.emit();
    this.close();
  }

  close() {
    this.modal.close();
  }

}
